import React from 'react';
import { CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
const finalPlans = [{
  id: 'megakit',
  name: 'MEGAKIT CALISTENIA CERO LÍMITES',
  includes: '6 Tomos + 6 Bonos · Todos los niveles',
  oldPrice: '$51.000',
  price: '$19.990 ARS',
  cta: 'QUIERO MI MEGAKIT',
  featured: false
}, {
  id: 'megakit-pro',
  name: 'MEGAKIT + PROGRAMACIÓN PERSONALIZADA ⭐',
  includes: '6 Tomos + 6 Bonos + Mesociclo a medida',
  oldPrice: '$69.000',
  price: '$27.990 ARS',
  cta: 'QUIERO EL MEGAKIT + PROGRAMACIÓN',
  featured: true
}];
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="cierre-title" data-id="element-78" data-mp="1o4ddcrvru1kq">
      <div className="mx-auto max-w-5xl" data-id="element-79" data-mp="221jsmchadi57">
        <h2 id="cierre-title" className="sr-only" data-id="element-80" data-mp="1x51pti5intvi">
          Última oportunidad al precio de lanzamiento
        </h2>

        <CountdownTimer heading="⏰ El precio cierra en:" data-id="element-81" data-mp="n6nsn2tp2cyw" />

        <div className="mt-8 grid gap-5 lg:grid-cols-2" data-id="element-82" data-mp="s4pdntaokmd0">
          {finalPlans.map(plan => <article key={plan.id} className={`flex flex-col rounded-3xl border p-6 sm:p-8 ${plan.featured ? 'border-gold bg-surface shadow-gold' : 'border-line bg-surface'}`} data-id="element-83" data-mp="x3s86jt1ba6q">
              <h3 className="text-lg font-extrabold leading-tight tracking-tight text-white sm:text-xl" data-id="element-84" data-mp="162mamqt1qus7">
                🏋️ {plan.name}
              </h3>
              <p className="mt-2 text-sm text-neutral-400" data-id="element-85" data-mp="1fvbbysuvus9t">{plan.includes}</p>
              <div className="mt-5 flex flex-wrap items-baseline gap-3" data-id="element-86" data-mp="1ktwcyuhylfzb">
                <span className="text-base text-neutral-600 line-through" data-id="element-87" data-mp="1psfyitsn4pr5">
                  {plan.oldPrice}
                </span>
                <span className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-88" data-mp="1tt9nlqhtkalm">
                  {plan.price}
                </span>
              </div>
              <div className="mt-6 flex-1" data-id="element-89" data-mp="3lvkqcajnx81p" />
              <CtaButton variant={plan.featured ? 'primary' : 'outline'} data-id="element-90" data-mp="3lwvpty62rtn0">
                {plan.cta}
              </CtaButton>
            </article>)}
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs font-medium text-neutral-500" data-id="element-91" data-mp="3uvr0bmg5jpw4">
          <li className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="dehevfdrz4i8">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="8gy10gkzotqt" />
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="mgz13ttfjx58">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="me4kkddjewh3" />
            Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-96" data-mp="2o7u4b6pyuylz">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="2o8c5mhrhk30r" />
            Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-98" data-mp="2k8bjeay5anj5">
            <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="2a3d0a0zl5rxx" />
            Mercado Pago | Tarjeta | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}